import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {matchPath, withRouter} from 'react-router';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {getCompanies, getPrograms, getTeams} from './utils/actions';

class BreadcrumbsItem extends Component {

  constructor(props) {
    super(props);

    const path = this.props.history.location.pathname;
    const teams = matchPath(path, { path: '/companies/:companyId/programs/:programId/teams/:teamId', exact: false, strict: false }) || {};
    const programs = matchPath(path, { path: '/companies/:companyId/programs/:programId', exact: false, strict: false }) || {};
    const companies = matchPath(path, { path: '/companies/:companyId', exact: false, strict: false }) || {};

    this.state = {
      params: { ...teams.params, ...programs.params, ...companies.params }
    };
  }


  componentWillMount() {
    const children = typeof this.props.children === 'string' ? this.props.children : this.props.children.props.children;

    if (children === 'Team Dashboard') {
      let teamId = this.state.params.teamId;

      if (!this.props.teams[teamId]) {
        this.props.fetchTeams({ teamId });
      }
    } else if (children === 'Program Dashboard') {
      let programId = this.state.params.programId;

      if (!this.props.programs[programId]) {
        this.props.fetchPrograms({ programId });
      }
    } else if (children === 'Company Dashboard') {
      let companyId = this.state.params.companyId;

      if (!this.props.companies[companyId]) {
        this.props.fetchCompanies({ id: companyId });
      }
    }
  }

  findBreadcrumbName = () => {
    const children = typeof this.props.children === 'string' ? this.props.children : this.props.children.props.children;
    let breadCrumbItem = [];

    switch (children) {
      case 'Team Dashboard':
        let teamId = this.state.params.teamId;

        if (this.props.teams.data[teamId]) {
          breadCrumbItem = [this.props.teams.data[teamId]];
        }
        break;
      case 'Program Dashboard':
        let programId = this.state.params.programId;

        if (this.props.programs.data[programId]) {
          breadCrumbItem = [this.props.programs.data[programId]];
        }
        break;
      case 'Company Dashboard':
        let companyId = this.state.params.companyId;

        if (this.props.companies.data[companyId]) {
          breadCrumbItem = [this.props.companies.data[companyId]];
        }
        break;
      default:
        break;
    }

    if (breadCrumbItem && breadCrumbItem.length > 0) {
      return this.props.isActive ? breadCrumbItem[0].name :
        <Link to={this.props.children.props.to}>{breadCrumbItem[0].name}</Link>;
    } else {
      return this.props.children;
    }
  };

  render() {
    return (
        <li className={ this.props.isActive ? 'active' : '' } >{this.findBreadcrumbName()}</li>
    );
  }
}

BreadcrumbsItem.propTypes = {
  isActive: PropTypes.bool
};

const mapStateToProps = state => {
  const { companies, programs, teams } = state;

  return ({ companies, programs, teams });
};

const mapDispatchToProps = dispatch => {
  return ({
    fetchCompanies: (query) => dispatch(getCompanies(query)),
    fetchPrograms: (query) => dispatch(getPrograms(query)),
    fetchTeams: (query) => dispatch(getTeams(query)),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BreadcrumbsItem));



// WEBPACK FOOTER //
// ./src/components/BreadcrumbsItem.js